<template>
    <aside class="c-upgradableSubscription" v-if="isReady">
        <div class="l-container">
            <div class="c-upgradableSubscription_title">
                <h1 class="c-upgradableSubscription_title_h1">
                    {{ this.companyName }} pode ter mais visibilidade com o plano {{this.requirements.eligiblePlan}}!
                </h1>
                <img @click="postToggleUpgradableBanner()" class="c-upgradableSubscription_closeIcon" :src="require('icon/custom/modal-close-white.svg')" alt="fechar" title="fechar">
            </div>
            <div class="c-upgradableSubscription_incentive">
                <div class="c-upgradableSubscription_incentive_image">
                    <img :src="require('icon/custom/increasing-laptop.svg')" alt="Imagem">
                </div>
                <div class="c-upgradableSubscription_incentive_title">
                    <h2>Conheça os benefícios do plano {{this.requirements.eligiblePlan}}:</h2>
                    <div class="m-listSquare">
                        <li class="m-listSquare_item">{{ this.requirements.visibilityBenefit }}</li>
                        <li class="m-listSquare_item">{{ this.requirements.priorityBenefit }}</li>
                        <li class="m-listSquare_item">{{ this.requirements.creditBenefit }}</li>
                    </div>
                </div>
                <div class="c-upgradableSubscription_incentive_button">
                    <a :href="this.getCheckoutUrl" @click="postToggleUpgradableBanner()">{{ buttonSubscriptionPlan }}</a>
                </div>
            </div>
        </div>
    </aside>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { closeAllModals } from 'Services/vueModal'
import historyOrigin from 'Enums/historyOrigin'
import subscriptionPeriods from 'Enums/subscriptionPeriods'
import { notifyError } from 'Services/vueNotifier'
import { StoreState } from 'Types'
import { checkout } from 'routes'

const initialState = () => ({
    isUpgradable: true,
})

export default {
  created() {
    if (this.isAuthenticated && this.companyName) {
        this.getUpgradable()
    }
  },

  data() {
    return initialState()
  },

  computed: {
    ...mapState({
        requesting: (state: StoreState) => state.upgradableSubscription.requesting,
        requirements: (state: StoreState) => state.upgradableSubscription.requirements,
        bannerClosed: (state: StoreState) => state.upgradableSubscription.bannerClosed,
        eligiblePlanId: (state: StoreState) => state.upgradableSubscription.eligiblePlanId,
        buttonSubscriptionPlan: (state: StoreState) => state.upgradableSubscription.buttonSubscriptionPlan,
        isAuthenticated: state => state.account.authenticated,
        companyName: state => state.account.company.name,
    }),

    isReady() {
      return !this.requesting.loading && this.requesting.sucess !== null && this.requirements.isUpgradable && !this.bannerClosed && this.isAuthenticated
    },
    getCheckoutUrl() {
      return checkout.index + `?plan=${this.eligiblePlanId}&period=${subscriptionPeriods.monthly}`
    },
  },

  methods: {
    ...mapActions({
        getUpgradable: 'upgradableSubscription/getUpgradable',
        postToggleUpgradableBanner: 'upgradableSubscription/postToggleUpgradableBanner',
    }),
  },
}
</script>

<style lang="scss" scoped>
@import "~css/_references";
@import '~css/Modules/button';

.c-upgradableSubscription {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    background-color: #00665D;
    z-index: 2;
    &_title {
        width: 100%;
        @media (max-width: 768px) {
            display: flex;
        }
       &_h1 {
        color: #FFDC91;
        font-size: 20px;
        font-family: Montserrat;
        display: inline-block;
       }
    }
    &_closeIcon {
        height: 20px;
        float: right;
        cursor: pointer;
        @media (max-width: 768px) {
            margin-left: 16px;
        }
    }

    &_incentive {
        display: grid;
        grid-template-columns: auto repeat(2, 1fr);
        grid-template-rows: 1fr;
        gap: 32px;
        width: 100%;
        align-items: center;
        margin-top: 18px;
        @media (max-width: 768px) {
            display: block;
        }

        &_image {
            grid-column: 1 / 2;
            display: flex;
            justify-content: center;
            @media (max-width: 768px) {
                display: none;
            }

            img {
            max-width: 100%;
            height: auto;
            }
        }

        &_title {
            grid-column: 2 / 3;

            h2 {
                margin-top: 0;
                color: #FFFFFF;
                font-size: 16px;
                margin-bottom: 18px;
            }
        }

        &_button {
            grid-column: 3 / 4;
            display: flex;
            justify-content: flex-end;
            @media (max-width: 768px) {
                display: block;
            }

            a {
                @extend .m-button;
                @extend .m-button--primary;
                @media (min-width: 768px) {
                    max-width: 300px;
                }
                width: 100%;
                cursor: pointer;
            }
        }
    }
}

.m-listSquare_item {
    color: #FFF;
    font-size: 14px;
}

.m-listSquare_item::before {
    background: #FEE08D;
}

</style>